import { addColumns } from '@nozbe/watermelondb/Schema/migrations'

export default {
  toVersion: 16,
  steps: [
    addColumns({
      table: 'chats',
      columns: [
        { name: 'is_last_session', type: 'boolean' },
        { name: 'is_owner', type: 'boolean' }
      ]
    })
  ]
}
